import classes from './input.module.css'

const Input = {
  classNames: {
    input: classes.input,
  },
}

export default Input
